export const apiUri = 'https://6t60ukv5ak.execute-api.us-east-2.amazonaws.com/default';